export default "__VITE_ASSET__C4C9XtFp__"